module.exports = __webpack_public_path__ + "static/media/ConvertSpreadsheetsToAPI.b3d89ad7.svg";